var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWetransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wetransfer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85911 14.5609C9.69104 14.2954 9.55349 14.1548 9.30898 14.1548C9.06446 14.1548 8.92692 14.2954 8.75882 14.5609L8.02528 15.7326C7.7502 16.1856 7.52097 16.4981 6.98609 16.4981C6.45122 16.4981 6.20671 16.2793 5.94692 15.6701C5.62599 14.9202 5.28978 14.0142 4.98414 12.7957C4.64794 11.4364 4.49512 10.5928 4.49512 9.90544C4.49512 9.21808 4.70907 8.81192 5.4426 8.67132C6.45122 8.48386 7.81133 8.37451 9.30898 8.37451C10.8066 8.37451 12.1667 8.48386 13.1753 8.67132C13.9089 8.81192 14.1228 9.21808 14.1228 9.90544C14.1228 10.5928 13.97 11.4364 13.6338 12.7957C13.3281 14.0142 12.992 14.9202 12.671 15.6701C12.4112 16.2793 12.1667 16.4981 11.6318 16.4981C11.097 16.4981 10.8677 16.1856 10.5927 15.7326L9.85911 14.5609ZM21.4888 15.6574C20.9692 16.2198 19.9912 16.6259 18.7075 16.6259C16.1248 16.6259 14.5966 14.8295 14.5966 12.4706C14.5966 9.93986 16.354 8.44018 18.6311 8.44018C20.6636 8.44018 22.0084 9.51808 22.0084 10.9709C22.0084 12.3456 20.8623 13.236 19.5633 13.236C18.8603 13.236 18.3407 13.0955 17.9892 12.8142C17.8517 12.7049 17.7753 12.7205 17.7753 12.8455C17.7753 13.361 17.9587 13.7984 18.2949 14.1421C18.5699 14.4233 19.0895 14.6108 19.5786 14.6108C20.0829 14.6108 20.5261 14.5014 20.9234 14.2983C21.3207 14.0952 21.657 14.1577 21.8556 14.4858C22.0849 14.8607 21.7639 15.345 21.4888 15.6574Z",
    fill: "#16162C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWetransfer);
export default __webpack_public_path__ + "static/media/wetransfer.41949ed73cc36fe876b9690b97600cb8.svg";
export { ForwardRef as ReactComponent };